import React from 'react';
import { theme } from '../../theme';

export interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  className?: string;
  label?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'medium', color, className = '', label = 'Loading...' }) => {
  const getSizeStyles = () => {
    const sizes = {
      small: { width: 16, height: 16, borderWidth: 2 },
      medium: { width: 24, height: 24, borderWidth: 3 },
      large: { width: 32, height: 32, borderWidth: 4 },
    };
    return sizes[size];
  };

  const sizeStyles = getSizeStyles();
  const spinnerColor = color || theme.colors.brand.primary;

  const spinnerStyles = {
    ...sizeStyles,
    borderRadius: '50%',
    border: `${sizeStyles.borderWidth}px solid ${theme.colors.border.lighter}`,
    borderTopColor: spinnerColor,
    animation: 'spin 1s linear infinite',
    display: 'inline-block',
  };

  // Create keyframes animation
  const keyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  React.useEffect(() => {
    // Inject keyframes if not already present
    const styleId = 'loading-spinner-keyframes';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = keyframes;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <div style={spinnerStyles} className={className} role="status" aria-label={label} aria-live="polite">
      <span
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        {label}
      </span>
    </div>
  );
};

export default LoadingSpinner;
